import {observable} from 'mobx';
import {Language} from './language';
import {LanguageLocaleKey} from './language-locale-key';
import {construct, createInstance, ModelProperties} from 'utils';

export class LanguageLocaleContent {
    @observable id!: number;

    @observable contentEdited: string = '';

    @observable contentVerified: string = '';

    @observable verified: boolean = false;

    @observable outdated: boolean = false;

    @observable languageId!: number;

    @observable keyId!: number;

    @observable language?: Language;

    @observable key?: LanguageLocaleKey;

    constructor(content?: ModelProperties<LanguageLocaleContent>) {
        if (content) {
            construct(this, content);
            this.language = createInstance(Language, content.language);
            this.key = createInstance(LanguageLocaleKey, content.key);
        }
    }
}